import constants from "../constants";
export const initialSubscriptionPagesStateValues = {
  isNoticiesFeatureEnabled: false,
  isTaskFeatureEnabled: false,
  isNotesAndReminderFeatureEnabled: false,
  isPerformanceReviewFeatureEnabled: false,
  isDiscussionNotesFeatureEnabled: false,
  isPatientAppointmentFeatureEnabled: false,
  isPatientConversationFeatureEnabled: false,
  isSchedulerFeatureEnabled: false,
  isTeamConversationFeatureEnabled: false,
  subscriptionPlanId: 0,
};

const subscriptionPlanModuleAccess = (planFeatures) => {
  return planFeatures.reduce((prev, currentValue) => {
    const key = constants.ModuleIds[currentValue.id];
    if (key) {
      prev[key] = currentValue.isAvailable;
    }
    return prev;
  }, initialSubscriptionPagesStateValues);
};
export const subscriptionReturnValues = (state = [], ownerId) => {
  if (state?.planFeature) {
    // for owner
    const values = subscriptionPlanModuleAccess(state?.planFeature);
    values.subscriptionPlanId = state.subscriptionPlan;
    return values;
  }
  if (!state?.length || !ownerId) return initialSubscriptionPagesStateValues;
  // for staff with ownerId
  const selectedOwner = state?.find((owners) => ownerId === owners?.ownerId);
  if (selectedOwner?.planFeature) {
    const values = subscriptionPlanModuleAccess(selectedOwner?.planFeature);
    values.subscriptionPlanId = selectedOwner.subscriptionPlan;
    return values;
  }
  return initialSubscriptionPagesStateValues;
};
export default function Subscription(state, action) {
  switch (action.type) {
    case constants.SUBSCRIPTIONMODULEADDED:
      if (action?.payload?.planFeature) {
        // use for owner
        action.payload.planfeatureAccessForPages = subscriptionPlanModuleAccess(
          action?.payload?.planFeature
        );
        action.payload.planfeatureAccessForPages.subscriptionPlanId =
          action.payload.subscriptionPlan;
      }
      return action?.payload;
    case constants.SUBSCRIPTIONMODULEREMOVED:
      return {};
    default:
      return state || {};
  }
}
